import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 6.44761L5.84766 4.49761L8.00016 2.54761",
  stroke: "black",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.73242 8.76506C3.73242 9.61256 3.97992 10.4376 4.45242 11.1351C4.92492 11.8401 5.58492 12.3801 6.36492 12.7101C7.14492 13.0326 7.99992 13.1151 8.83242 12.9501C9.65742 12.7851 10.4224 12.3801 11.0149 11.7801C11.6149 11.1801 12.0199 10.4226 12.1849 9.59756C12.3499 8.77256 12.2674 7.91006 11.9449 7.13006C11.6224 6.35006 11.0749 5.68256 10.3699 5.21756C9.67242 4.74506 8.84742 4.49756 7.99992 4.49756H5.84742",
  stroke: "black",
  strokeLinecap: "round"
}));
export { IconReset };